import { z } from "zod";

/**
 * Zod schema for EnumAssociationDTO
 * Transforms serialized timestamp strings to Date objects
 */
export const EnumAssociationSchema = z.object({
  id: z.string().uuid(),
  entityType: z.string(),
  entityTypeDisplayName: z.string(),
  entityId: z.string().uuid(),
  entityName: z.string().nullable(),
  entityDescription: z.string().nullable(),
  optionId: z.string().uuid(),
  optionName: z.string().nullable(),
  createdAt: z.string().transform((s) => new Date(s)),
});

/**
 * Type inferred from EnumAssociationSchema
 */
export type EnumAssociationDTO = z.infer<typeof EnumAssociationSchema>;
